import React, { Component } from "react";

import YouTube from 'react-youtube'

class Biblioteca extends Component {
    constructor(props) {
        super(props)
        this.state = {
            active: '',
            video: ''
        }

        this.kitActive = this.kitActive.bind(this)
        this.otrosActive = this.otrosActive.bind(this)
        this.changeVideo = this.changeVideo.bind(this)
        this.kitFormacion = this.kitFormacion.bind(this)
    }

    kitActive() {
        this.setState({
            active: 'kit',
            video: ''
        })
    }

    otrosActive() {
        this.setState({
            active: 'otros',
            video: ''
        })
    }

    changeVideo(event) {
        this.setState({
            video: event.target.getAttribute('value')
        })
    }

    kitFormacion() {
        return (
            <>
                <ul className="descarga">
                    <li><a value="kSg1P2xJJq8" className={(this.state.video == 'kSg1P2xJJq8') ? 'link active' : 'link'} onClick={this.changeVideo}>La Position Kangourou</a></li>
                    <li><a value="r2eT2PdVY44" className={(this.state.video == 'r2eT2PdVY44') ? 'link active' : 'link'} onClick={this.changeVideo}>Unité de Soins Intensifs Neonatale, ouverte 24 heures sur 24</a></li>
                    <li><a value="WvBbZI6LQDs" className={(this.state.video == 'WvBbZI6LQDs') ? 'link active' : 'link'} onClick={this.changeVideo}>Comment allaiter un bébé prématuré</a></li>
                    <li><a value="fU1XFsGeEa8" className={(this.state.video == 'fU1XFsGeEa8') ? 'link active' : 'link'} onClick={this.changeVideo}>Début de l’adaptation kangourou intrahospitaliere</a></li>
                    <li><a value="P6fnBcnS14Q" className={(this.state.video == 'P6fnBcnS14Q') ? 'link active' : 'link'} onClick={this.changeVideo}>Nourrir le prématuré autrement</a></li>
                    <li><a value="nxRSivL9v-c" className={(this.state.video == 'nxRSivL9v-c') ? 'link active' : 'link'} onClick={this.changeVideo}>Puériculture kangourou</a></li>
                    <li><a value="P4paqGnbOm0" className={(this.state.video == 'P4paqGnbOm0') ? 'link active' : 'link'} onClick={this.changeVideo}>Massage en position kangourou</a></li>
                    <li><a value="AAp6D66x3vc" className={(this.state.video == 'AAp6D66x3vc') ? 'link active' : 'link'} onClick={this.changeVideo}>Évaluation neurologique pendant le suivi ambulatoire après 40 semaines</a></li>
                    <li><a value="xYLNp6OKw_c" className={(this.state.video == 'xYLNp6OKw_c') ? 'link active' : 'link'} onClick={this.changeVideo}>Suivi ambulatoire</a></li>
                    <li><a value="dB4souaGCjk" className={(this.state.video == 'dB4souaGCjk') ? 'link active' : 'link'} onClick={this.changeVideo}>Évaluation Neurologique pendant le suivi ambulatoire après 40 semaines</a></li>
                    <li><a value="3CB4zvvZYgo" className={(this.state.video == '3CB4zvvZYgo') ? 'link active' : 'link'} onClick={this.changeVideo}>Evaluation du développement psychomoteur</a></li>
                    <li><a value="wZ8tD-pyGPc" className={(this.state.video == 'wZ8tD-pyGPc') ? 'link active' : 'link'} onClick={this.changeVideo}>Visite à domicile</a></li>
                    <li><a value="UYGRvcfc7cY" className={(this.state.video == 'UYGRvcfc7cY') ? 'link active' : 'link'} onClick={this.changeVideo}>Thérapie physique dans l’Unité de soins intermédiaires</a></li>
                    <li><a value="I6biwXt90q4" className={(this.state.video == 'I6biwXt90q4') ? 'link active' : 'link'} onClick={this.changeVideo}>Massage Vietnamien</a></li>
                    <li><a value="b5EITq456Zo" className={(this.state.video == 'b5EITq456Zo') ? 'link active' : 'link'} onClick={this.changeVideo}>Thérapie physique Ambulatoire</a></li>
                    <li><a value="UFvyyVlXzcc" className={(this.state.video == 'UFvyyVlXzcc') ? 'link active' : 'link'} onClick={this.changeVideo}>Examen Nuero Moteur au cours des cinq premieres annees de la vie</a></li>
                </ul>
            </>
        )
    }

    otrosKit() {
        return (
            <>
                {/* <p><b>Hospital Universitario 12 de Octubre. Madrid, España</b></p> */}
                <ul className="descarga">
                    <li><a value="yLC7AoAbmc8" className={(this.state.video == 'yLC7AoAbmc8') ? 'link active' : 'link'} onClick={this.changeVideo}>Maman kangourou</a></li>
                    <li><a value="kvziL2yk2HY" className={(this.state.video == 'kvziL2yk2HY') ? 'link active' : 'link'} onClick={this.changeVideo}>Mise de Redouane en peau à peau</a></li>
                    <li><a value="xIAAY-Y56d4" className={(this.state.video == 'xIAAY-Y56d4') ? 'link active' : 'link'} onClick={this.changeVideo}>À fleur de peau</a></li>
                    <li><a value="uYUAy2touBs" className={(this.state.video == 'uYUAy2touBs') ? 'link active' : 'link'} onClick={this.changeVideo}>L'adaptation Kangourou</a></li>
                    <li><a value="FPW6IowE-Us" className={(this.state.video == 'FPW6IowE-Us') ? 'link active' : 'link'} onClick={this.changeVideo}>La Méthode Mère Kangourou</a></li>
                    <li><a value="FPW6IowE-Us" className={(this.state.video == 'FPW6IowE-Us') ? 'link active' : 'link'} onClick={this.changeVideo}>La Méthode Mère Kangourou</a></li>
                    <li><a value="FPW6IowE-Us" className={(this.state.video == 'FPW6IowE-Us') ? 'link active' : 'link'} onClick={this.changeVideo}>La Méthode Mère Kangourou</a></li>
                    <li><a value="FPW6IowE-Us" className={(this.state.video == 'FPW6IowE-Us') ? 'link active' : 'link'} onClick={this.changeVideo}>La Méthode Mère Kangourou</a></li>
                </ul>
            </>
        )
    }

    render() {
        var block = ''
        var video = ''
        if (this.state.active == 'kit') {
            block = this.kitFormacion()
        } else if (this.state.active == 'otros') {
            block = this.otrosKit()
        }

        if (this.state.video != '') {
            video = <YouTube videoId={this.state.video} />
        }
        return (
            <>
                <section id="insideDoc">
                    <h2>Multimédia</h2>
                    <div className="acordeon">
                        <div className={(this.state.active == 'kit') ? 'item active kit' : 'item kit'} onClick={this.kitActive}>
                            <div className="img">
                                <div className="name">Kit de formation</div>
                            </div>
                        </div>
                        <div className={(this.state.active == 'otros') ? 'item active otros' : 'item otros'} onClick={this.otrosActive}>
                            <div className="img">
                                <div className="name">Autres videos</div>
                            </div>
                        </div>
                    </div>

                    <div className="insideAcordeon">
                        {video}
                        {block}
                    </div>
                </section>
            </>
        )
    }
}

export default Biblioteca;